
import { apiClient } from "./ApiClient"


export const getSweepsByWardAndZone = (ward, zone) => apiClient.post(`/showsweeps`, {ward, zone})

export const addUser = (user) => apiClient.post(`/home`, user)

export const verifyResponse = (token) => apiClient.post(`/verify?token=${token}`)

export const unsubscribe = (request) => apiClient.post(`/unsubscribe`, request)

export const sendEmail = (userContact) => apiClient.post(`/contact`, userContact)